"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.LoadProgressBar = void 0;
var React = __importStar(require("react"));
var react_1 = require("@xstate/react");
var classnames_1 = __importDefault(require("classnames"));
var video_context_1 = require("../../context/video-context");
var selectors_1 = require("../../selectors");
var slider_1 = require("@reach/slider");
var LoadProgressBar = function (_a) {
    var className = _a.className;
    var videoService = (0, video_context_1.useVideo)();
    var duration = (0, react_1.useSelector)(videoService, selectors_1.selectDuration);
    var buffered = (0, react_1.useSelector)(videoService, selectors_1.selectBuffered);
    if (!buffered || !buffered.length) {
        return null;
    }
    var bufferedEnd = buffered.end(buffered.length - 1);
    if (bufferedEnd > duration) {
        bufferedEnd = duration;
    }
    // get the percent width of a time compared to the total end
    function percentify(time, end) {
        var percent = time / end || 0; // no NaN
        return (percent >= 1 ? 1 : percent) * 100;
    }
    // the width of the progress bar
    var style = { width: '0%' };
    style.width = "".concat(percentify(bufferedEnd, duration), "%");
    var parts = [];
    // add child elements to represent the individual buffered time ranges
    for (var i = 0; i < buffered.length; i++) {
        var start = buffered.start(i);
        var end = buffered.end(i);
        // set the percent based on the width of the progress bar (bufferedEnd)
        var part = (React.createElement(slider_1.SliderMarker, { value: percentify(start, bufferedEnd), style: {
                width: percentify(end - start, bufferedEnd) + '%'
            }, key: "part-".concat(i) }));
        parts.push(part);
    }
    if (parts.length === 0) {
        parts = undefined;
    }
    return (React.createElement("div", { style: style, className: (0, classnames_1["default"])('cueplayer-react-load-progress', className) },
        React.createElement("span", { className: "cueplayer-react-control-text" },
            "Loaded: ",
            percentify(bufferedEnd, duration).toFixed(0),
            "%"),
        parts));
};
exports.LoadProgressBar = LoadProgressBar;
